module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1029-48846e55769dbb0455b2a8cd22afed6b.png";